<template>
  <div class="col-6 card-wrapper">
    <div class="card mb-4">
      <!-- Card header -->
      <div class="card-header">
        <h3 class="mb-0">Agregar una nueva variedad</h3>
      </div>
      <!-- Card body -->
      <div class="card-body">
        <!-- Form groups used in grid -->
        <form class="needs-validation" @submit.prevent="save">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Nombre (*) </label>

                <el-input v-model="formData.name" v-validate="modelValidations.name" name="name" placeholder="Nombre">
                </el-input>

                <small v-show="name.invalid" class="text-danger">
                  {{ getError('name') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Descripción (*) </label>

                <el-input
                  v-model="formData.description"
                  v-validate="modelValidations.description"
                  name="description"
                  placeholder="Descripción"
                >
                </el-input>

                <small v-show="description.invalid" class="text-danger">
                  {{ getError('description') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Cultivo </label>

                <el-select
                  v-model="formData.crop"
                  v-validate="modelValidations.crop"
                  autocomplete="off"
                  filterable
                  name="crop"
                  placeholder="Seleccione el cultivo"
                  :disabled="variety.id !== null"
                >
                  <el-option
                    v-for="option in cropsOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  >
                  </el-option>
                </el-select>

                <small v-show="crop.invalid" class="text-danger">
                  {{ getError('crop') }}
                </small>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <el-checkbox
                  v-model="formData.forSale"
                  :disabled="variety.id !== null"
                  label="Variedad para venta"
                  name="forSale"
                >
                </el-checkbox>
              </div>
            </div>

            <div class="col-md-8 text-right">
              <base-button native-type="submit" type="primary">Guardar</base-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate';
import { Select, Option, Checkbox } from 'element-ui';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Checkbox.name]: Checkbox,
  },

  props: {
    variety: {
      type: Object,
      default: () => {
        return {
          id: null,
          name: null,
          description: null,
          crop: null,
          forSale: true,
        };
      },
    },
  },

  data() {
    return {
      validated: false,
      crops: [],
      formData: {
        name: this.variety.name,
        description: this.variety.description,
        crop: this.variety.crop,
        forSale: Boolean(this.variety.forSale),
      },

      modelValidations: {
        name: {
          required: true,
          min: 3,
        },

        description: {
          required: true,
          min: 5,
        },

        crop: {
          required: true,
        },
      },
    };
  },

  computed: {
    ...mapFields(['name', 'description', 'crop', 'forSale']),
    cropsOptions() {
      return this.$selectOptions(this.crops, { sort: true });
    },
  },

  mounted() {
    this.fetchCrops();
  },

  methods: {
    fetchCrops() {
      this.$services
        .resource('crops')
        .get()
        .then((res) => res.data.data)
        .then((data) => (this.crops = data.crops));
    },

    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    save() {
      this.firstFormSubmit().then((res) => {
        if (res) {
          this.$emit('save', this.formData);
        }
      });
    },

    getError(name) {
      return this.errors.first(name);
    },

    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
  },
};
</script>

<style scoped>
.form-group .el-date-editor--date {
  width: 100%;
}
</style>
